export default __webpack_public_path__ + "static/fischer-38d43ad739a1413d26d5445dca6657b7.jpg";